import { Component, OnInit } from '@angular/core';
import { FileService } from '../../shared/_services/file.service';
import { HttpEventType } from '@angular/common/http';


@Component({
  selector: 'app-devolutions',
  templateUrl: './devolutions.component.html',
  styleUrls: ['./devolutions.component.css']
})
export class DevolutionsComponent implements OnInit {

  error: string;
  totalCount: any;
  correctCount: any;
  incorrectCount: any;
  success: any;

  constructor(
    private fileUploadService: FileService,
  ) { }

  ngOnInit() {
  }

  upload(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (let file of files)
      formData.append(file.name, file);

    this.fileUploadService.uploadFileDevolution(formData)
      .subscribe((res: any) => {
        this.error = undefined;
        this.success = "Estados de devolución cargados";
        setTimeout(() => {
          this.success = "";
        }, 7000);
        //this.showResults(res);
      },
      err => {
          this.success = undefined;
          this.error = err;
          this.cleanError;
        }
      );
  }

  cleanError() {
    setTimeout(() => {
      this.error = "";
    }, 7000);
  }

  showResults(res:any) {
    this.totalCount = res.totalCount;
    this.correctCount = res.correctCount;
  }

  DowloadResult() { }

}
